// PWA — src/lib/notifPrefsSync.ts — 2026-07-09 (QuietHours_As_TenantSetting)
//
// Decides the initial notification prefs when Settings mounts:
//   - Server already configured -> server wins (per-ACCOUNT truth; the old
//     localStorage value was per-device).
//   - Server not configured but this device has a localStorage value ->
//     one-time MIGRATION: adopt the local value and push it to the server so
//     nobody loses the setting they had.
//   - Neither -> defaults (quiet hours off — matches pre-migration behavior).
import type { ServerNotifPrefs } from './api';

export function resolveInitialPrefs(
  server: { configured: boolean; prefs: ServerNotifPrefs | null },
  local: ServerNotifPrefs | null,
  defaults: ServerNotifPrefs,
): { prefs: ServerNotifPrefs; migrate: boolean } {
  if (server.configured && server.prefs) {
    return { prefs: server.prefs, migrate: false };
  }
  if (local) {
    return { prefs: local, migrate: true };
  }
  return { prefs: defaults, migrate: false };
}
